export const DEFAULT_PROFILE_PIC = 'assets/images/default_profile_pic.png';
export const WINDOW_SCROLL_SIZE = 20;